// Module
var code = `<s-multi-select-general-items class="d-block multi-select-general-modal" items="items" on-item-toggle="onItemToggle()"/> `;
// Exports
var _module_exports =code;;
var path = '/common/directives/multiSelectGeneral/multiSelectGeneralItems/multiSelectGeneralItemsModal/multiSelectGeneral.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;